// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "pl-" + chunkId + "." + {"474":"e1af92d5","708":"bb05443c","823":"0cb18719"}[chunkId] + ".js";
};